/**
 * 品牌配置模块
 * 从 Vite 注入的全局变量中获取品牌配置
 */

import type { BrandConfig } from '../../../configs/types'

// 导出类型供其他模块使用
export type { BrandConfig, BrandFeatures, BrandResources, BrandTheme, BrandTexts } from '../../../configs/types'

/**
 * 当前品牌配置
 * 由 vite.config.ts 通过 define 注入
 */
export const brandConfig: BrandConfig = __BRAND_CONFIG__

function prefixCDN<T>(obj: T, cdn: string): T {
  if (typeof obj === 'string')
    return (obj.startsWith('/') ? cdn + obj : obj) as T
  if (typeof obj === 'object' && obj !== null) {
    const result = {} as T
    for (const key in obj)
      (result as any)[key] = prefixCDN((obj as any)[key], cdn)
    return result
  }
  return obj
}

// 具体配置导出, 在页面中使用
export const { brand } = brandConfig
const cdn = import.meta.env.DEV ? '' : (import.meta.env.VITE_CDN || '').replace(/\/$/, '')
export const resources = prefixCDN(brandConfig.resources, cdn)
export const { theme } = brandConfig
export const { texts } = brandConfig
export const { features } = brandConfig
export const { environments } = brandConfig

// 基础主题色
export const { primaryColor } = theme || {}
export const { appName } = texts || {}

// 主题色（从 theme 中解构）
export const colors = {
  primary: theme.primaryColor,
  text: {
    primary: theme.textPrimary,
    secondary: theme.textSecondary,
    tertiary: theme.textTertiary,
    inverse: theme.textInverse,
  },
  bg: {
    global: theme.bgGlobal,
    card: theme.bgCard,
    tag: theme.bgTag,
  },
  border: {
    primary: theme.borderPrimary,
  },
}
